import { showServerErrorToast } from "../services/toasts";
import { GOOGLE_CLIENT_ID } from "../constants";
import { googleSignInByToken } from "../services/api";

const maybeShowGoogleOneTapPrompt = () => {
  const oneTapShowable = document.querySelector("meta[name='google-one-tap-showable']");

  if (!oneTapShowable || !window.google?.accounts.id) {
    return;
  }

  window.google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: onGoogleOneTapCallback,
  });

  try {
    window.google.accounts.id.prompt();
  } catch {
    // ignore
  }
};

const onGoogleOneTapCallback = (response: google.accounts.id.CredentialResponse) => {
  googleSignInByToken(response.credential)
    .then(() => {
      window.location.reload();
    })
    .catch((error) => {
      console.error("GoogleOneTap: Google Sign In error", error);
      showServerErrorToast();
    });
};

document.addEventListener("DOMContentLoaded", () => {
  maybeShowGoogleOneTapPrompt();
});
